import Vue from 'vue'

import {
  Vuetify, // required
  VApp, // required
  VNavigationDrawer,
  VFooter,
  VList,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VBtn,
  VBottomNav,
  VDivider,
  VSubheader,
  VTextField,
  VTextarea,
  VSelect,
  VCheckbox,
  VForm,
  VProgressCircular,
  VMenu,
  VDatePicker,
  VSnackbar,
  VTooltip,
  VDialog,
  VBadge,
  VCard,
  VAlert,
  VCombobox,
  VRadioGroup,
  VProgressLinear
} from 'vuetify'

import { Resize, Scroll } from 'vuetify/es5/directives'

import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VBtn,
    VBottomNav,
    VDivider,
    VSubheader,
    VTextField,
    VTextarea,
    VSelect,
    VCheckbox,
    VForm,
    VProgressCircular,
    VMenu,
    VDatePicker,
    VSnackbar,
    VTooltip,
    VDialog,
    VCard,
    VBadge,
    VCombobox,
    VRadioGroup,
    VProgressLinear,
    VAlert
  },
  directives: {
    Resize,
    Scroll
  },
  theme: {
    primary: '#f07838'
  }
})
